function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { translateFieldName, translate } from '../../utils/helpers';
import { API_URL } from '../../utils/constant';
import _deburr from 'lodash/deburr';
import { throttle, debounce } from 'throttle-debounce';
import Loader from '../Loader';
import { Services } from '../../utils/Services';

var SdsPage = /*#__PURE__*/function (_Component) {
  _inherits(SdsPage, _Component);

  var _super = _createSuper(SdsPage);

  function SdsPage(props) {
    var _this;

    _classCallCheck(this, SdsPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchProducts", function () {
      _this.setState({
        loadingProduct: true
      });

      Services.searchProducts(_this.state.search_text).then(function (data) {
        _this.setState({
          categories: data.categories,
          pagination: data.pagination,
          products: data.products,
          autoComplete: [],
          loadingProduct: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSearchIcon", function () {
      return document.querySelector('#shop-page').getAttribute('search-icon');
    });

    _defineProperty(_assertThisInitialized(_this), "search", function (val) {
      //evt.preventDefault()
      if (val !== '') {
        _this.fetchProducts();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "autoCompleteClick", function (val) {
      _this.setState({
        search_text: val,
        q: val,
        autoComplete: []
      }, function () {
        _this.search(val);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setSearchTxt", function (event) {
      _this.setState({
        search_text: event.target.value,
        q: event.target.value
      }, function () {
        var q = _this.state.q;

        if (q.length < 5 || q.endsWith(' ')) {
          _this.autocompleteSearchThrottled(_this.state.q.trim());
        } else {
          _this.autocompleteSearchDebounced(_this.state.q.trim());
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "autocompleteSearch", function (q) {
      _this.fetchAutoComplete(q);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchAutoComplete", function (q) {
      _this.qWaitingFor = q;

      if (q === _this.qWaitingFor) {
        var url = API_URL + '/products/autocomplete?term=' + _deburr(_this.state.q).toLowerCase().trim();

        var sap_id = document.querySelector('body').getAttribute('sap-id');

        if (sap_id) {
          url = url + '&sap_id=' + sap_id;
        }

        fetch(url).then(function (response) {
          if (!response.ok) {
            throw response;
          }

          return response.json();
        }).then(function (data) {
          _this.setState({
            autoComplete: data
          });
        }).catch(function () {//   console.log(error)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyPress", function (e) {
      if (e.key === 'Enter') {
        _this.setState({
          autoComplete: []
        }, _this.search(e));
      }
    });

    _this.searchRef = /*#__PURE__*/React.createRef();
    _this.state = {
      products: [],
      categories: [],
      pagination: {},
      search_text: '',
      autoComplete: '',
      loadingProduct: false
    };
    _this.autocompleteSearchDebounced = debounce(500, _this.autocompleteSearch);
    _this.autocompleteSearchThrottled = throttle(500, _this.autocompleteSearch);
    return _this;
  }

  _createClass(SdsPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.querySelector('.shop-root').classList.add('sds');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.querySelector('.shop-root').classList.remove('sds');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "container sds-page"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "main-bg-after"
      }, translate('Search for Safety Data Sheets', 'Recherche de fiche de données de sécurité')), /*#__PURE__*/React.createElement("div", {
        className: "row search-line"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-lg-6 col-sm-12 search"
      }, translate('Enter a product name or code to search', 'Rentrez un nom de produit ou un code produit'), /*#__PURE__*/React.createElement("div", {
        className: "search-bar"
      }, /*#__PURE__*/React.createElement("input", {
        className: "sds-search-input d-lg-flex",
        type: "text",
        placeholder: translate('Product name or product code', 'Nom ou code produit'),
        onChange: this.setSearchTxt,
        value: this.state.search_text,
        onKeyPress: this._handleKeyPress,
        ref: this.searchRef
      }), /*#__PURE__*/React.createElement("div", {
        className: "autoListe"
      }, this.state.autoComplete.length > 0 ? this.state.autoComplete.map(function (auto, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "autoListeItem",
          onMouseDown: function onMouseDown() {
            return _this2.autoCompleteClick(auto.value);
          }
        }, auto.label);
      }) : null), /*#__PURE__*/React.createElement("img", {
        className: "search-icon",
        src: this.getSearchIcon(),
        alt: "",
        onClick: function onClick(evt) {
          return _this2.search(evt);
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-lg-6 col-sm-12 notes"
      }, translate('Notes', 'Notes'), /*#__PURE__*/React.createElement("p", null, translate('Search and download SDS documents. If you have any questions about the SDS, the products and our services, please contact our Customer Service.', "Rechercher et télécharger les FDS de nos produits. Pour des questions d'ordre général concernant les fiches de données de sécurité, nos produits et nos services, veuillez contacter le service à la clientèle.")))), !this.state.loadingProduct ? /*#__PURE__*/React.createElement("div", {
        className: "sds-lines"
      }, this.state.products > '0' ? /*#__PURE__*/React.createElement("div", {
        className: "row sds-lines-header d-flex flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-lg-6 col-sm-4 name-code align"
      }, /*#__PURE__*/React.createElement("div", {
        className: "code align"
      }, /*#__PURE__*/React.createElement("strong", null, translate('CODE', 'CODE'))), /*#__PURE__*/React.createElement("div", {
        className: "name align"
      }, /*#__PURE__*/React.createElement("strong", {
        className: ""
      }, translate('NAME', 'NOM')))), /*#__PURE__*/React.createElement("div", {
        className: "col-lg-3 col-sm-4 see-button align"
      }, /*#__PURE__*/React.createElement("strong", {
        className: "sds"
      }, translate('SDS', 'SDS'))), /*#__PURE__*/React.createElement("div", {
        className: "col-lg-3 col-sm-4 see-button align"
      }, /*#__PURE__*/React.createElement("strong", {
        className: "product-sheet"
      }, translate('PRODUCT SHEET', 'FICHE PRODUIT')))) : null, this.state.products.map(function (product) {
        return /*#__PURE__*/React.createElement("div", {
          key: product.id,
          className: "row sds-line"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-lg-6 col-sm-4 name-code align"
        }, /*#__PURE__*/React.createElement("div", {
          className: "code align"
        }, /*#__PURE__*/React.createElement("span", null, product[translateFieldName('code')])), /*#__PURE__*/React.createElement("div", {
          className: "name align"
        }, /*#__PURE__*/React.createElement("span", null, product[translateFieldName('name')]))), /*#__PURE__*/React.createElement("div", {
          className: "col-lg-3 col-sm-4 see-button align"
        }, product[translateFieldName('msds')].url ? /*#__PURE__*/React.createElement("a", {
          className: "btn main-bg main-border",
          href: API_URL + product[translateFieldName('msds')].url,
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-eye",
          "aria-hidden": "true"
        }), translate('SEE', 'VOIR')) : null), /*#__PURE__*/React.createElement("div", {
          className: "col-lg-3 col-sm-4 see-button align"
        }, product[translateFieldName('product_file')].url ? /*#__PURE__*/React.createElement("a", {
          className: "btn main-bg main-border",
          href: API_URL + product[translateFieldName('product_file')].url,
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-eye",
          "aria-hidden": "true"
        }), translate('SEE', 'VOIR')) : null));
      })) : /*#__PURE__*/React.createElement("div", {
        className: "col-12  text-center loading"
      }, /*#__PURE__*/React.createElement(Loader, null)));
    }
  }]);

  return SdsPage;
}(Component);

export default SdsPage;